import { useCallback } from 'react'
import { ModalOpenedSetTy } from '../../../../../../baseComponents/Modal/types'
import { InputTableLayoutData } from '../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { CustomSelectWithSearchBar } from '../../../../../../forms/CustomSelect'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { OrderData } from '../../../../../inputTableLayouts/order/OrderLayout/types'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../baseComponents/Modal'

interface ModalOrderRefundConflictsWarehousesProps extends ModalOrderRefundConflictsWarehousesLogicProps {
    data: OrderData
    conflicts: TwinDictionary
 }

const ModalOrderRefundConflictsWarehouses: React.FC<ModalOrderRefundConflictsWarehousesProps> = ({ data, conflicts, setOpened,  ...logic }) => {
    const { handleSelectWarehouse, handleOnAccept } = useModalOrderRefundConflictsWarehousesLogic({ setOpened, ...logic })
    const { t } = useTwinTranslation()
    const myWarehouseDict = dictionaryComplexFromJsonArr(conflicts['warehouses'])
    return (
        <ModalSmallCentered opened={Object.keys(conflicts)?.length ? true : null} setOpened={() => undefined} onClickOut={false} className='flex_height' >
            <h2>{t('chooseDefaultWarehouse', 'Debes escoger el almacén por defecto')}</h2>
            <span className='my-20'>{t('chooseWarehouseToProductWithNoWarehouse', 'Selecciona el almacén que quieres asignar a los productos con almacén no especificado')}</span>
            <div className='mt-10 mb-40'>
                <CustomSelectWithSearchBar className='w-200 m-auto' label={t('warehouse', 'Almacén')} items={myWarehouseDict} value={data.header.WarehouseId} onChange={handleSelectWarehouse} />
            </div>
            <ButtonsModalSmallCentered setOpened={() => undefined} onCancel={() => { setOpened(null) }} confirmText={t('accept', 'Aceptar')} onAccept={handleOnAccept}/>
        </ModalSmallCentered>
    )
}

interface ModalOrderRefundConflictsWarehousesLogicProps {
    setConflicts: React.Dispatch<React.SetStateAction<TwinDictionary | null>>
    setCompleteData: React.Dispatch<React.SetStateAction<InputTableLayoutData | null >>
    setOpened: ModalOpenedSetTy
}

const useModalOrderRefundConflictsWarehousesLogic = ({ setCompleteData, setConflicts, setOpened }: ModalOrderRefundConflictsWarehousesLogicProps) => {
    const handleSelectWarehouse = useCallback((value: any) => {
        setCompleteData((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.header['WarehouseId'] = value
            return copyOld
        })
    }, [setCompleteData])

    const handleOnAccept = useCallback(() => {
        setConflicts((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            delete copyOld['warehouse']
            return null
        })
        setOpened(true)
    }, [setConflicts, setOpened])
    return { handleSelectWarehouse, handleOnAccept }
}


export default ModalOrderRefundConflictsWarehouses